import React, { useContext, useEffect, useRef, useState } from "react";
// import "../../styles/component/popup/CustomizeTabsModal.css";

import Style from "./style.module.css";

import { useFormik } from "formik";
import * as yup from "yup";
// import XCloseIcon from "../../component/icons/x-close";
import Select from "react-select";
import { Trash2 } from "lucide-react";
import { useApiCall } from "../../custom-hooks/api-call";
import { GlobalContext } from "../../../context/Context";
import Tooltip from "../../ui/tooltip";
import {
   FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  FormLineBreak,
  SelectSearch,
 } from "../../form/form-layout";
import LeftSidePopupLayout from "../../popup/modal-layout";
import XCloseIcon from "../../icons/x-close";


const BulkEdit = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  users = [],
  BrandList = [],
  Countries = [],
  UsersList = [],
}) => {
  const apiCall = useApiCall();

  const [mainProducts, setMainProducts] = useState([]);
  const [subProducts, setSubProducts] = useState([]);
  const [packages, setPackages] = useState([]);
  const [loadingMain, setLoadingMain] = useState(false);
  const [loadingSub, setLoadingSub] = useState(false);

  const initialMainId = null;
  const initialSubId = null;
  // const initialPackageId = CustomerData?.deal_package
  //   ? Number(metas.deal_package)
  //   : null;

  let { state, dispatch } = useContext(GlobalContext);

  const userOptions = UsersList.map((agents) => ({
    value: agents.userid,
    label: agents.name,
  }));

  const countryOptions = Countries?.map((country) => ({
    value: country.country_code,
    label: country.country_name,
  }));

  const brandOptions = BrandList?.map((mp) => ({
    value: mp.brandsid,
    label: mp.brandname,
  }));

  const handleLeadSource = (selectId) => {
    const selectedBrandId = selectId;
    // console.log(selectedBrandId);

    // formik.setFieldValue("deal_package", selectedPackageId);

    // Find selected package
    const selected = BrandList?.find((pkg) => pkg?.brandsid == selectedBrandId);

    // console.log("selected", selected);

    // Set selected package features
    // if (selected) {
    //   setBrandUrl(selected?.brandurl || "");
    // } else {
    //   setBrandUrl("");
    // }
  };

  const AddField = () => {
    const newFields = [
      ...formik.values.extra_meta,
      { meta_key: "", meta_value: "" },
    ];
    formik.setFieldValue("extra_meta", newFields);
  };

  const DeleteField = (index) => {
    const newFields = formik.values.extra_meta.filter((_, i) => i !== index);
    formik.setFieldValue("extra_meta", newFields);
  };

  const validationSchema = yup.object({
    customerFullName: yup.string().required("Name is required"),
    industry: yup.string().required("industry is required"),
    brandid: yup.string().required("brandid is required"),
    main_product: yup.string().required("main product is required"),
    product: yup.string().required("product is required"),
    // country: yup.string().required("country is required"),
    state: yup.string().required("state is required"),
    city: yup.string().required("city is required"),
    lead_assigned: yup
      .array()
      .of(yup.string())
      .min(1, "This Field is Required")
      .required("This Field is Required"),
  });

  const formik = useFormik({
    initialValues: {
      customerFullName: "",
      industry: "",
      brandid: "",
      main_product: initialMainId || "",
      product: "",
      subject: "",
      message: "",
      country: "",
      state: "",
      city: "",
      lead_assigned: "",
      extra_meta: [],
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      let extra_meta = values.extra_meta.map((item) => ({
        key: item.meta_key,
        value: item.meta_value,
      }));

      extra_meta.push({
        key: "main_product",
        value: values.main_product,
      });

      const data = {
        lead_ids: users?.lead_ids,
        user_ids: users?.user_ids,
        customerFullName: values.customerFullName || "",
        country: values.country,
        product: values.product,
        brandid: Number(values.brandid),
        lead_assigned: values.lead_assigned.map((id) => Number(id)),
        city: values.city,
        state: values.state,
        industry: values.industry,
        message: values.message,
        extra_meta: extra_meta,
      };

      // console.log("values",values);
      // console.log("Extra",extra_meta);

      try {
        const apiRes = await apiCall({
          method: "post",
          url: "leads/edit-bulk-custom-lead",
          data,
        });

        formik.resetForm();
        onSubmit(apiRes?.message || "Request Submitted");
        onClose();
      } catch (error) {
        console.log("Error", error);
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.message ||
            "Something went wrong"
        );
      }
    },
  });

  useEffect(() => {
    loadMainProducts();
  }, []);

  useEffect(() => {
    if (initialMainId) {
      loadSubProducts(initialMainId).then(() => {
        // if (initialSubId) {
        //   loadPackages(initialSubId);
        // }
      });
    } else if (initialSubId) {
      // loadPackages(initialSubId);
    }
  }, [initialMainId, initialSubId]);

  const loadMainProducts = async () => {
    setLoadingMain(true);
    try {
      const res = await apiCall({
        method: "get",
        url: "products/products-list?is_paginate=0",
      });
      setMainProducts(res?.data || []);
    } catch (err) {
      console.warn("Error loading main products:", err);
    } finally {
      setLoadingMain(false);
    }
  };

  const loadSubProducts = async (mainId) => {
    if (!mainId) {
      setSubProducts([]);
      return;
    }
    setLoadingSub(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-products/${mainId}`,
      });
      setSubProducts(res?.data || []);
    } catch (err) {
      console.warn("Error loading sub-products:", err);
      setSubProducts([]);
    } finally {
      setLoadingSub(false);
    }
  };

  // const loadPackages = async (subProductId) => {
  //   if (!subProductId) {
  //     setPackages([]);
  //     return;
  //   }
  //   setLoadingPackages(true);
  //   try {
  //     const res = await apiCall({
  //       method: "get",
  //       url: `products/get-sub-product-packages/${subProductId}`,
  //     });
  //     setPackages(res?.data || []);
  //   } catch (err) {
  //     console.warn("Error loading packages:", err);
  //     setPackages([]);
  //   } finally {
  //     setLoadingPackages(false);
  //   }
  // };

  // Handlers for selects
  const handleMainSelect = async (option) => {
    const id = option?.value || "";

    formik.setFieldValue("main_product", id);

    formik.setFieldValue("product", "");
    // formik.setFieldValue("deal_package_id", "");
    // formik.setFieldValue("deal_package", "");
    setSubProducts([]);
    // setPackages([]);

    if (id) {
      await loadSubProducts(id);
    }
  };

  const handleSubSelect = async (option) => {
    const id = option?.value || "";
    formik.setFieldValue("product", id);

    // formik.setFieldValue("deal_package_id", "");
    // formik.setFieldValue("deal_package", "");
    // setPackages([]);

    // if (id) {
    //   await loadPackages(id);
    // }
  };

  // const handlePackageSelect = (option) => {
  //   const id = option?.value || "";
  //   const pkg = packages.find((p) => Number(p.packageid) === Number(id));
  //   // formik.setFieldValue("deal_package_id", id);
  //   // formik.setFieldValue("deal_package", id || "");

  //   // set features from package if exists
  //   if (pkg?.features) {
  //     formik.setFieldValue("features", stripHtml(pkg.features || ""));
  //     setPackageFeatures(pkg?.features || "");
  //   } else {
  //     formik.setFieldValue("features", "");
  //     setPackageFeatures("");
  //   }
  // };

  const subProductsUnique = subProducts.filter(
    (v, i, a) =>
      a.findIndex(
        (t) =>
          Number(t.id ?? t.subproductid ?? t.productid) ===
          Number(v.id ?? v.subproductid ?? v.productid)
      ) === i
  );
  const packagesUnique = packages.filter(
    (v, i, a) =>
      a.findIndex((t) => Number(t.packageid) === Number(v.packageid)) === i
  );

  const mainOptions = mainProducts.map((mp) => ({
    value: mp.id ?? mp.productid ?? mp.main_product_id ?? mp.id,
    label: mp.products || mp.name || mp.title || `#${mp.id}`,
  }));
  const subOptions = subProductsUnique.map((sp) => ({
    value: sp.id ?? sp.subproductid ?? sp.productid,
    label: sp.products || sp.name || sp.title || `#${sp.id}`,
  }));

  // console.log("opt", subOptions);
  // const packageOptions = [
  //   ...packagesUnique.map((pk) => ({
  //     value: pk.packageid,
  //     label: pk.packagename || `#${pk.packageid}`,
  //   })),
  //   { value: 3, label: "Other" },
  // ];

  // useEffect(() => {
  //   let mounted = true;
  //   const runPrefill = async () => {
  //     try {
  //       if (editMainId) {
  //         formik.setFieldValue("main_product", editMainId, false);

  //         await loadSubProducts(editMainId);
  //       }

  //       if (editSubId) {
  //         const existsInSub = subProducts.some(
  //           (sp) =>
  //             Number(sp.id ?? sp.subproductid ?? sp.productid) ===
  //             Number(editSubId)
  //         );
  //         if (!existsInSub) {
  //           setSubProducts((prev) => {
  //             const merged = [
  //               ...prev,
  //               {
  //                 id: editSubId,
  //                 products:
  //                   CustomerData?.product_name || `Product #${editSubId}`,
  //               },
  //             ];

  //             const unique = merged.filter(
  //               (v, i, a) =>
  //                 a.findIndex(
  //                   (t) =>
  //                     Number(t.id ?? t.subproductid ?? t.productid) ===
  //                     Number(v.id ?? v.subproductid ?? v.productid)
  //                 ) === i
  //             );
  //             return unique;
  //           });
  //         }

  //         formik.setFieldValue("product", editSubId, false);

  //         await loadPackages(editSubId);

  //         if (editPackageId) {
  //           const existsPkg = packages.some(
  //             (pk) => Number(pk.packageid) === Number(editPackageId)
  //           );
  //           if (!existsPkg) {
  //             setPackages((prev) => {
  //               const merged = [
  //                 ...prev,
  //                 {
  //                   packageid: editPackageId,
  //                   packagename: metas?.packagename,
  //                 },
  //               ];

  //               const unique = merged.filter(
  //                 (v, i, a) =>
  //                   a.findIndex(
  //                     (t) => Number(t.packageid) === Number(v.packageid)
  //                   ) === i
  //               );
  //               return unique;
  //             });
  //           }

  //           // formik.setFieldValue("deal_package_id", editPackageId, false);

  //           // formik.setFieldValue(
  //           //   "deal_package",
  //           //   CustomerData?.deal_package || metas?.deal_package_name || "",
  //           //   false
  //           // );
  //         }
  //       } else if (!editSubId && editPackageId) {
  //         const existsPkg = packages.some(
  //           (pk) => Number(pk.packageid) === Number(editPackageId)
  //         );
  //         if (!existsPkg) {
  //           setPackages((prev) => {
  //             const merged = [
  //               ...prev,
  //               {
  //                 packageid: editPackageId,
  //                 packagename: metas?.packagename,
  //               },
  //             ];

  //             const unique = merged.filter(
  //               (v, i, a) =>
  //                 a.findIndex(
  //                   (t) => Number(t.packageid) === Number(v.packageid)
  //                 ) === i
  //             );
  //             return unique;
  //           });
  //         }
  //         // formik.setFieldValue("deal_package_id", editPackageId, false);
  //       }
  //     } catch (err) {}
  //   };

  //   if (CustomerData) {
  //     runPrefill();
  //   }

  //   return () => {
  //     mounted = false;
  //   };
  // }, [CustomerData]);

  const selectedMainOption =
    mainOptions.find(
      (o) => Number(o.value) === Number(formik.values.main_product)
    ) || null;
  const selectedSubOption =
    subOptions.find((o) => Number(o.value) === Number(formik.values.product)) ||
    null;
  // const selectedPackageOption =
  //   packageOptions.find(
  //     (o) => Number(o.value) === Number(formik.values.deal_package)
  //   ) || null;

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        key={1}
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head}`}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4>Bulk Edit</h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody} !relative`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3 `}>
                <FormArea>
                  {/* Name */}
                  <FeildWraper width="100%">
                    <FormLabel required>Name</FormLabel>
                    <input
                      name="customerFullName"
                      value={formik.values.customerFullName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter Name"
                    />
                    {formik.touched.customerFullName &&
                      formik.errors.customerFullName && (
                        <FeildError>
                          {formik.errors.customerFullName}
                        </FeildError>
                      )}
                  </FeildWraper>

                  {/* country */}
                  <FeildWraper width="100%">
                    <FormLabel required>Country</FormLabel>
                    <SelectSearch
                      menuPosition="fixed"
                      name="country"
                      placeholder="- Select country -"
                      onChange={(val) => {
                        formik.setFieldValue("country", val);
                      }}
                      value={formik.values.country}
                      options={countryOptions}
                    />
                    {formik.touched.country && formik.errors.country && (
                      <FeildError>{formik.errors.country}</FeildError>
                    )}
                  </FeildWraper>

                  {/* lead_assigned */}

                  <FeildWraper>
                    <FormLabel required>Assigned</FormLabel>

                    <Select
                      name="lead_assigned"
                      isMulti
                      className="text-sm"
                      classNamePrefix="react-select"
                      options={userOptions}
                      components={{
                        IndicatorSeparator: () => null,
                        LoadingIndicator: () => null,
                      }}
                      value={userOptions.filter((option) =>
                        Array.isArray(formik.values.lead_assigned)
                          ? formik.values.lead_assigned.includes(option.value)
                          : false
                      )}
                      onChange={(selectedOptions) => {
                        const ids = selectedOptions.map((opt) => opt.value);
                        formik.setFieldValue("lead_assigned", ids);
                      }}
                      filterOption={(option, inputValue) =>
                        option.label
                          .toLowerCase()
                          .includes(inputValue.toLowerCase())
                      }
                      placeholder="Search or select users..."
                      isClearable
                      menuPlacement="auto"
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "35px",
                          height: "auto",
                          borderRadius: "5px",
                          border: "1px solid #DFDFDF",
                          backgroundColor: state.isDisabled
                            ? "#f0f0f0"
                            : "#FFF",
                          boxShadow: state.isFocused ? "none" : "none",
                          "&:hover": { borderColor: "#DFDFDF" },
                          fontSize: "13px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                          padding: "0 14px",
                          cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          height: "auto",
                          padding: "0 0px 0",
                        }),
                        input: (base) => ({
                          ...base,
                          margin: 0,
                          padding: 0,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                          height: "auto",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#717680",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 99999,
                        }),
                        menu: (base) => ({
                          ...base,
                          marginTop: "2px",
                          borderRadius: "5px",
                          border: "1px solid #DFDFDF",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }),
                        option: (base, state) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: state.isSelected ? "#FFF" : "#1E1E1E",
                          backgroundColor: state.isSelected
                            ? "#3b82f6"
                            : state.isFocused
                            ? "#F3F4F6"
                            : "#FFF",
                          padding: "8px 14px",
                          cursor: "pointer",
                        }),
                        indicatorContainer: (base) => ({ ...base, padding: 0 }),
                        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                      }}
                    />
                    {formik.touched.lead_assigned &&
                      formik.errors.lead_assigned && (
                        <FeildError>{formik.errors.lead_assigned}</FeildError>
                      )}
                  </FeildWraper>

                  {/* Brand */}

                  <FeildWraper>
                    <FormLabel required>Brand</FormLabel>
                    <Select
                      name="brandid"
                      className="text-sm"
                      classNamePrefix="react-select"
                      options={brandOptions}
                      components={{
                        IndicatorSeparator: () => null,
                        LoadingIndicator: () => null,
                      }}
                      value={brandOptions?.find(
                        (option) => option.value === formik.values.brandid
                      )}
                      onChange={(selectedOption) => {
                        formik.setFieldValue(
                          "brandid",
                          selectedOption?.value || ""
                        );
                        handleLeadSource(selectedOption?.value);
                      }}
                      filterOption={(option, inputValue) =>
                        option.label
                          .toLowerCase()
                          .includes(inputValue.toLowerCase())
                      }
                      placeholder="Search or select Brands..."
                      isClearable
                      menuPlacement="auto"
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "35px",
                          height: "auto",
                          borderRadius: "5px",
                          border: "1px solid #DFDFDF",
                          backgroundColor: state.isDisabled
                            ? "#f0f0f0"
                            : "#FFF",
                          boxShadow: state.isFocused ? "none" : "none",
                          "&:hover": { borderColor: "#DFDFDF" },
                          fontSize: "13px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                          padding: "0 14px",
                          cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          height: "auto",
                          padding: "0 0px 0",
                        }),
                        input: (base) => ({
                          ...base,
                          margin: 0,
                          padding: 0,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                          height: "auto",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#717680",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 99999,
                        }),
                        menu: (base) => ({
                          ...base,
                          marginTop: "2px",
                          borderRadius: "5px",
                          border: "1px solid #DFDFDF",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }),
                        option: (base, state) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: state.isSelected ? "#FFF" : "#1E1E1E",
                          backgroundColor: state.isSelected
                            ? "#3b82f6"
                            : state.isFocused
                            ? "#F3F4F6"
                            : "#FFF",
                          padding: "8px 14px",
                          cursor: "pointer",
                        }),
                        indicatorContainer: (base) => ({ ...base, padding: 0 }),
                        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                      }}
                    />
                    {formik.touched.brandid && formik.errors.brandid && (
                      <FeildError>{formik.errors.brandid}</FeildError>
                    )}
                  </FeildWraper>

                  {/* Main Product */}

                  <FeildWraper>
                    <FormLabel required>Main Product</FormLabel>
                    <Select
                      className="text-sm"
                      classNamePrefix="react-select"
                      value={selectedMainOption}
                      onChange={handleMainSelect}
                      options={mainOptions}
                      isLoading={loadingMain}
                      isClearable
                      placeholder="Select main product..."
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      components={{
                        IndicatorSeparator: () => null,
                        LoadingIndicator: () => null,
                      }}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "35px",
                          height: "auto",
                          borderRadius: "5px",
                          border: "1px solid #DFDFDF",
                          backgroundColor: state.isDisabled
                            ? "#f0f0f0"
                            : "#FFF",
                          boxShadow: state.isFocused ? "none" : "none",
                          "&:hover": { borderColor: "#DFDFDF" },
                          fontSize: "13px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                          padding: "0 14px",
                          cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          height: "auto",
                          padding: "0 0px 0",
                        }),
                        input: (base) => ({
                          ...base,
                          margin: 0,
                          padding: 0,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                          height: "auto",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#717680",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 99999,
                        }),
                        menu: (base) => ({
                          ...base,
                          marginTop: "2px",
                          borderRadius: "5px",
                          border: "1px solid #DFDFDF",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }),
                        option: (base, state) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: state.isSelected ? "#FFF" : "#1E1E1E",
                          backgroundColor: state.isSelected
                            ? "#3b82f6"
                            : state.isFocused
                            ? "#F3F4F6"
                            : "#FFF",
                          padding: "8px 14px",
                          cursor: "pointer",
                        }),
                        indicatorContainer: (base) => ({ ...base, padding: 0 }),
                        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                      }}
                    />
                    {formik.touched.main_product &&
                      formik.errors.main_product && (
                        <FeildError>{formik.errors.main_product}</FeildError>
                      )}
                  </FeildWraper>

                  {/* Sub product */}

                  <FeildWraper>
                    <FormLabel required>Sub Product</FormLabel>
                    <Select
                      value={
                        subOptions.find(
                          (option) => option.value == formik.values.product
                        ) || null
                      }
                      onChange={(selectedOption) => {
                        formik.setFieldValue(
                          "product",
                          selectedOption ? selectedOption.value : ""
                        );
                        handleSubSelect(selectedOption); // if you have custom logic
                      }}
                      options={subOptions}
                      isLoading={loadingSub}
                      isClearable
                      placeholder="Select sub product..."
                      classNamePrefix="react-select"
                      className="text-sm"
                      menuPortalTarget={document.body}
                      noOptionsMessage={() =>
                        formik.values.main_product
                          ? "No sub-products"
                          : "Select main product first"
                      }
                      menuPosition="fixed"
                      components={{
                        IndicatorSeparator: () => null,
                        LoadingIndicator: () => null,
                      }}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "35px",
                          height: "auto",
                          borderRadius: "5px",
                          border: "1px solid #DFDFDF",
                          backgroundColor: state.isDisabled
                            ? "#f0f0f0"
                            : "#FFF",
                          boxShadow: state.isFocused ? "none" : "none",
                          "&:hover": { borderColor: "#DFDFDF" },
                          fontSize: "13px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                          padding: "0 14px",
                          cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          height: "auto",
                          padding: "0 0px 0",
                        }),
                        input: (base) => ({
                          ...base,
                          margin: 0,
                          padding: 0,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                          height: "auto",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#717680",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 99999,
                        }),
                        menu: (base) => ({
                          ...base,
                          marginTop: "2px",
                          borderRadius: "5px",
                          border: "1px solid #DFDFDF",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }),
                        option: (base, state) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: state.isSelected ? "#FFF" : "#1E1E1E",
                          backgroundColor: state.isSelected
                            ? "#3b82f6"
                            : state.isFocused
                            ? "#F3F4F6"
                            : "#FFF",
                          padding: "8px 14px",
                          cursor: "pointer",
                        }),
                        indicatorContainer: (base) => ({ ...base, padding: 0 }),
                        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                      }}
                    />
                    {formik.touched.product && formik.errors.product && (
                      <FeildError>{formik.errors.product}</FeildError>
                    )}
                  </FeildWraper>

                  {/* state */}
                  <FeildWraper>
                    <FormLabel required>State</FormLabel>
                    <input
                      name="state"
                      value={formik.values.state}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter State"
                    />
                    {formik.touched.state && formik.errors.state && (
                      <FeildError>{formik.errors.state}</FeildError>
                    )}
                  </FeildWraper>

                  {/* city */}
                  <FeildWraper>
                    <FormLabel required>City</FormLabel>
                    <input
                      name="city"
                      value={formik.values.city}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter City"
                    />
                    {formik.touched.city && formik.errors.city && (
                      <FeildError>{formik.errors.city}</FeildError>
                    )}
                  </FeildWraper>

                  {/* Subject */}
                  <FeildWraper>
                    <FormLabel> Subject</FormLabel>
                    <input
                      name="subject"
                      value={formik.values.subject}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter  Subject"
                    />
                  </FeildWraper>

                  {/* Industry */}

                  <FeildWraper>
                    <FormLabel required> Industry</FormLabel>
                    <input
                      name="industry"
                      value={formik.values.industry}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter  Industry"
                    />
                    {formik.touched.industry && formik.errors.industry && (
                      <FeildError>{formik.errors.industry}</FeildError>
                    )}
                  </FeildWraper>

                  {/* Message */}
                  <FeildWraper width="100%">
                    <FormLabel>Message</FormLabel>
                    <input
                      name="message"
                      value={formik.values.message}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter Message"
                    />
                  </FeildWraper>

                  <FormLineBreak />

                  {formik?.values?.extra_meta.length > 0 && (
                    <div className={Style.tDividerWrapper}>
                      <div
                        className={Style.horizontalLine}
                        aria-hidden="true"
                      />
                      <div className={`${Style.dividerLabel} px-4`}>
                        Additional Fields
                      </div>
                    </div>
                  )}

                  {/*  Add more */}

                  <FeildWraper width="100%">
                    {formik?.values?.extra_meta.map((field, index) => (
                      <div className={`w-full flex gap-3`} key={index}>
                        {/* key */}

                        <input
                          type="text"
                          name={`extra_meta[${index}].meta_key`}
                          value={formik.values.extra_meta[index].meta_key}
                          onChange={formik.handleChange}
                          placeholder="key"
                        />

                        {/* value */}

                        <input
                          type="text"
                          name={`extra_meta[${index}].meta_value`}
                          value={formik.values.extra_meta[index].meta_value}
                          onChange={formik.handleChange}
                          placeholder="value"
                        />

                        <Tooltip
                          key={`${index}-asideBottomItems`}
                          className={`${Style.Tooltip}`}
                          boxClassName={Style.TooltipBox}
                          content="Delete Field"
                          position={"bottom center"}
                        >
                          <div
                            onClick={() => DeleteField(index)}
                            className="p-3 text-red-600"
                          >
                            <Trash2 size={18} />
                          </div>
                        </Tooltip>
                      </div>
                    ))}

                    <button
                      type="button"
                      onClick={AddField}
                      className="flex flex-start text-blue-700 font-medium   w-full p-2 text-[16px]"
                    >
                      + Add Field
                    </button>
                  </FeildWraper>
                </FormArea>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={`${Style.dcmb__submit}`}>
            Apply
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default BulkEdit;
